import { render, staticRenderFns } from "./PolicyPage.vue?vue&type=template&id=a11faf02&scoped=true&"
import script from "./PolicyPage.js?vue&type=script&lang=js&"
export * from "./PolicyPage.js?vue&type=script&lang=js&"
import style0 from "./PolicyPage.scss?vue&type=style&index=0&id=a11faf02&prod&lang=scss&scoped=true&"
import style1 from "./PolicyPage.vue?vue&type=style&index=1&id=a11faf02&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11faf02",
  null
  
)

export default component.exports